import { Session } from '@ais-ui/auth';

export const queueCsvVesselTrack = async (
  session: Session,
  mmsi: number
): Promise<{ queueUuid: string }> => {
  const response = await session.request('queueCsvVesselTrack', { mmsi });

  const queueUuid: string = response;

  return { queueUuid };
};

export const queueKmlVesselTrack = async (
  session: Session,
  mmsi: number
): Promise<{ queueUuid: string }> => {
  const response = await session.request('queueKmlVesselTrack', { mmsi });

  const queueUuid: string = response;

  return { queueUuid };
};

export const getQueueStatusOfVesselTrack = async (
  session: Session,
  queueUuid: string
): Promise<{
  errorMessage: '';
  percentComplete: number;
  status: 'QueuePending' | 'QueueComplete';
}> => {
  const response = await session.request('getQueueStatus', { queueUuid });

  return response;
};

export const getCsvVesselTrackResult = async (
  session: Session,
  queueUuid: string
): Promise<{
  data: string;
  filename: string;
}> => {
  const response = await session.request('getCsvVesselTrackResult', {
    queueUuid,
  });

  return response;
};

export const getKmlVesselTrackResult = async (
  session: Session,
  queueUuid: string
): Promise<{
  data: string;
  filename: string;
}> => {
  const response = await session.request('getKmlVesselTrackResult', {
    queueUuid,
  });

  return response;
};
